import { useState } from "react";
import BaseModal from "@components/modals/BaseModal";
import Button from "@components/ui/buttons/Button";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";

const PAUSE_REASONS = [
  "Pièces en attente",
  "En attente assistance technique",
  "Travaux complémentaires",
  "Diagnostic complémentaire",
  "Accord client en attente",
];

interface PauseChargeModalProps {
  clientName: string;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

export default function PauseChargeModal({
  clientName,
  onConfirm,
  onCancel,
}: PauseChargeModalProps) {
  const suggestions = PAUSE_REASONS;
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const reason = selectedReason || customReason;

  return (
    <BaseModal
      title="Mettre en pause"
      onClose={onCancel}
      width="max-w-md"
    >
      <div className="flex flex-col gap-4 p-4">
        <div className="text-h3" style={{ fontFamily: "Poppins", color: "#525252" }}>
          {`Indiquez la raison de la pause pour ${clientName} :`}
        </div>

        <div className="flex flex-col gap-2">
          {suggestions.map((s) => (
            <button
              key={s}
              className="text-left px-3 py-2 rounded-lg transition-colors text-h3"
              style={{
                background: selectedReason === s ? "#EEF2FF" : "#F9FAFB",
                border: selectedReason === s ? "1px solid #6366F1" : "1px solid #E5E7EB",
                color: selectedReason === s ? "#4338CA" : "#374151",
                fontFamily: "Poppins",
                cursor: "pointer",
              }}
              onClick={() => { setSelectedReason(s); setCustomReason(""); }}
            >
              {s}
            </button>
          ))}
        </div>

        <div>
          <input
            className="w-full px-3 py-2 rounded-lg text-h3"
            style={{
              border: "1px solid #E5E7EB",
              fontFamily: "Poppins",
              outline: "none",
              color: "#374151",
            }}
            placeholder="Autre raison..."
            value={customReason}
            onChange={(e) => { setCustomReason(e.target.value); setSelectedReason(""); }}
          />
        </div>
      </div>

      <div className="border-t p-4 flex flex-row justify-end gap-2">
        <SecondaryButton variant="small" onClick={onCancel}>
          Annuler
        </SecondaryButton>
        <Button
          variant="small"
          label="Mettre en pause"
          onClick={() => onConfirm(reason)}
          disabled={!reason.trim()}
        />
      </div>
    </BaseModal>
  );
}
